/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Directory_CtaInputs */

const en_directory_integrate_directory_cta = /** @type {(inputs: Directory_Integrate_Directory_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search products`)
};

const zh_directory_integrate_directory_cta = /** @type {(inputs: Directory_Integrate_Directory_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索产品`)
};

/**
* | output |
* | --- |
* | "Search products" |
*
* @param {Directory_Integrate_Directory_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_directory_cta = /** @type {((inputs?: Directory_Integrate_Directory_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Directory_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_directory_cta(inputs)
	return zh_directory_integrate_directory_cta(inputs)
});
export { directory_integrate_directory_cta as "directory.integrate.directory.cta" }